import { render, staticRenderFns } from "./NormalSearchNav220.vue?vue&type=template&id=1a40497c&scoped=true"
import script from "./NormalSearchNav220.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav220.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a40497c",
  null
  
)

export default component.exports